import React from 'react';
import styled from 'styled-components';

interface LoaderProps {
    size: number;
    gap: number;
    speed: number;
    delay: number;
}

const LoaderWrapper = styled('div')<{ size: number }>`
    width: ${props => props.size}px;
    margin: 0 auto;
`;

const Loader = styled('div')<LoaderProps>`
    position: relative;
    animation: dot-flashing ${props => props.speed}s infinite alternate;
    animation-delay: 0s;

    &,
    &::before,
    &::after {
        display: block;
        width: ${props => props.size}px;
        height: ${props => props.size}px;
        border-radius: 5px;
        color: ${props => props.theme.colors.white};
        background-color: ${props => props.theme.colors.white};
    }

    &::before,
    &::after {
        content: '';
        display: inline-block;
        position: absolute;
        top: 0;
    }

    &::before {
        left: ${props => props.size + props.gap}px;
        animation: dot-flashing ${props => props.speed}s infinite linear alternate;
        animation-delay: ${props => props.delay}s;
    }

    &::after {
        left: ${props => (props.size + props.gap) * 2}px;
        animation: dot-flashing ${props => props.speed}s infinite alternate;
        animation-delay: ${props => props.delay * 2}s;
    }

    @keyframes dot-flashing {
        0%,
        100% {
            background-color: ${props => props.theme.colors.white};
        }

        25%,
        50%,
        75% {
            background-color: rgba(255, 255, 255, 0.5);
        }
    }
`;

interface Props extends Partial<LoaderProps> {}

const Spinner: React.FunctionComponent<Props> = ({ size = 8, gap = 5, speed = 1, delay = 0.2 }) => (
    <LoaderWrapper size={(size + gap) * 3}>
        <Loader size={size} gap={gap} speed={speed} delay={delay} />
    </LoaderWrapper>
);

export default Spinner;
